// Domain 01 — Network Fundamentals
import u01 from './u01-roles.js';
import u02 from './u02-models.js';
import u03 from './u03-ethernet.js';
import u04 from './u04-devices.js';
import u05 from './u05-cabling.js';
import u06 from './u06-ipv4.js';
import u07 from './u07-subnetting.js';
import u08 from './u08-ipv6.js';
import u09 from './u09-tcpudp.js';
import u10 from './u10-ports.js';
import u11 from './u11-casting.js';
import u12 from './u12-connectivity.js';
import u13 from './u13-method.js';
import u14 from './u14-final.js';

export default {
  id: 'd01', number: '01', title: 'Network Fundamentals',
  tagline: 'Models, Ethernet, addressing, transport, and the troubleshooting method you will use for the rest of your career.',
  units: [u01, u02, u03, u04, u05, u06, u07, u08, u09, u10, u11, u12, u13, u14],
};
